const wp = window.wp
const wpApiSettings = window.wpApiSettings

export default new Promise (( resolve, reject ) => {
  const setup = () => {
    const Path = wp.api.models.Post.extend({
      version: 'ach/v1/',
      root: 'path',
      defaults: {
        path: ''
      },
      url() {
        return wpApiSettings.root + this.version + this.root + '/' +
           this.get( 'path' )
      }
    })

    const AdminPath = Path.extend({
      root: 'admin',
      defaults: {
        path: '',
        section: '',
        item: '',
      },
      url() {  
      const section = this.get( 'section' )
      const item = this.get( 'item' )
        return wpApiSettings.root + this.version + this.root + '/' +
           this.get( 'path' ) + ( section ? `/${section}` : '' ) +
           ( item ? `/${item}` : '' )
      }
    })

    const Program = Path.extend({
      root: 'program'
    })

    const Release = Path.extend({
      root: 'release',
      defaults: {
        program: '',
        release: ''
      },
      url() {
        return wpApiSettings.root + this.version + this.root + '/' +
           this.get( 'program' ) + '/' + this.get( 'release' )
      }
    })

    const Preview = Path.extend({
      root: 'preview'
    })

    const Membership = Path.extend({
      root: 'members'
    })

    const Menu = Path.extend({
      root: 'menu'
    })

    Object.assign( wp.api.models, {
      Path,
      AdminPath,
      Program,
      Release,
      Preview,
      Membership,
      Menu
    })

    // const Programs = wp.api.collections.Posts.extend( {
    //   url: wpApiSettings.root + 'wp/v2/custom_post_slug',
    //   model: Program,
    // } );

    wp.api.loadPromise.done(() => {
      resolve({ Path, AdminPath, Program, Release, Preview, Membership, Menu })
    })
  }

  var wait = null
  wait = window.setInterval( () => {
    if ( wp.api && wp.api.models && wp.api.models.Post ) {
      window.clearInterval( wait )
      setup()
    }
  }, 250 )
})
